import { render, staticRenderFns } from "./createonBoardingScreen.vue?vue&type=template&id=d255e89a&"
import script from "./createonBoardingScreen.vue?vue&type=script&lang=js&"
export * from "./createonBoardingScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports